<template>
    <div id="passWithOpinion">
        <div class="opinion-box">
            <van-field
                v-model="message"
                rows="5"
                type="textarea"
                placeholder="请输入处理意见"
                maxlength="500"
                show-word-limit
            />
            <div class="button-box">
                <van-button class="main-color" @click="showPicker = true" size="small">常用意见</van-button>
            </div>
            <van-button type="default" @click="$router.go(-1)" block size="normal">取消</van-button>
            <van-button class="main-color" @click="submitHandle" block size="normal">提交</van-button>
        </div>
        <van-popup v-model="showPicker" round position="bottom">
            <van-picker
                show-toolbar
                title="常用意见"
                :columns="opinions"
                @confirm="onConfirm"
                @cancel="showPicker = false"
            />
        </van-popup>
        <van-overlay :show="show">
            <div class="wrapper" @click.stop>
                <van-loading type="spinner" vertical>提交中...</van-loading>
            </div>
        </van-overlay>
    </div>
</template>

<script>
import {queryHandleApprovalOpinion, batchHandleCooperative} from '@/api/flow'
import {Field, Picker, Popup, Button, Loading, Overlay, Toast} from 'vant'
export default {
    name: "PassWithOpinion",
    components: {
        [Field.name]: Field,
        [Picker.name]: Picker,
        [Popup.name]: Popup,
        [Button.name]: Button,
        [Loading.name]: Loading,
        [Overlay.name]: Overlay
    },
    props: ['type', 'ids'],
    data() {
        return {
            opinions: [],
            message: '',
            showPicker: false,
            show: false
        }
    },
    created() {
        queryHandleApprovalOpinion().then(res => {
            res.forEach(item => {
                this.opinions.push(item.approvalOpinion);
            })
        })
    },
    methods: {
        onConfirm(value) {
            this.message = value;
            this.showPicker = false;
        },
        submitHandle() {
            this.show = true;
            let params =  { instIds: this.ids.join(','), logJson: JSON.stringify({ logmsg:this.message, handWritePath:"", ogtype:"cooper", optype: this.type }),annexJson: []};
            batchHandleCooperative(params).then(res => {
                if (res && res.code == 200) {
                    Toast.success(res.msg || '操作成功!')
                    this.$router.go(-1)
                } else {
                    Toast.fail(res.msg || '操作失败!')
                }
                this.show = false;
            })
        }
    }
}
</script>

<style lang="scss" scoped>
#passWithOpinion{
    height: 100vh;
    background: #fff;
    .opinion-box{
        padding: 15px;
        .van-field{
            border: 1px solid #e5e5e5;
            border-radius: 5px;
        }
    }
    .button-box{
        margin: 10px 0 50px;
        text-align: right;
        .van-button{
            margin-top: 0px;
        }
    }
    .van-button{
        margin-top: 15px;
    }
    .van-button.main-color{
        background: var(--main-color);
        border-color: var(--);
        color: #fff;
    }
    .wrapper{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
}
</style>